import {ProcessProperty} from "./process-property";
import {ProcessType} from "./process-type";
import {ProcessPropertySet} from "./process-property-set";

export class Process {
    formId: number;
    key: string;
    name: string;
    description: string;
    processType: ProcessType;
    model: string;

    template: string;
    templateId: number;

    publicOutputInd: boolean;
    outputName: string;
    propertySets: ProcessPropertySet[];
    level: number;

    children?: Process[];

    // locale: boolean;
    // mode: boolean;

}
